// Purpose: render button elements for popup forms
define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/constants',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Util, Constants, Component) => {
  const VALID_STYLE_ATTRS = [
    'color',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'lineHeight',
    'textShadow',
  ];

  const { copyToClipboard, containsPrize } = Util;

  @Component()
  class Button extends React.Component {
    static propTypes = {
      disabled: PropTypes.bool,
      text: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      style: PropTypes.instanceOf(Immutable.Map),
      onClickAction: PropTypes.func.isRequired,
      currentStep: PropTypes.string.isRequired,
      winningOption: PropTypes.instanceOf(Immutable.Map).isRequired,
      discountCode: PropTypes.string.isRequired,
      isPreview: PropTypes.bool.isRequired,
      boxShadowStyle: PropTypes.instanceOf(Object).isRequired,
      onMouseEnter: PropTypes.func.isRequired,
      onMouseLeave: PropTypes.func.isRequired,
    };

    static defaultProps = {
      disabled: false,
      style: Immutable.Map(),
    };

    constructor(props) {
      super(props);

      this.onClick = this.onClick.bind(this);

      this.state = {
        copied: false,
      };
    }

    onClick(event) {
      const {
        action,
        onClickAction,
        currentStep,
        winningOption,
        discountCode,
        isPreview,
        text,
      } = this.props;

      // Prevent any possibility of page reload from default button submit action
      event.preventDefault();

      // Perform discount/game related action before set action
      if (currentStep === 'success' && !isPreview) {
        const prizeType = winningOption ? winningOption.get('prizeType') : null;

        if (containsPrize(text)) {
          if (prizeType === 'discount' || discountCode) {
            copyToClipboard(discountCode);
            this.setState({ copied: true });

            setTimeout(() => {
              if (onClickAction) onClickAction(action || 'submit', this, event);
            }, 2000);

            return;
          } else if (prizeType === 'content') {
            window.open(winningOption.get('mediaSrc'), '_blank');
          }
        }
      }

      if (onClickAction) onClickAction(action || 'submit', this, event);
    }

    render() {
      const {
        disabled,
        boxShadowStyle,
        onMouseEnter,
        onMouseLeave,
        isPreview,
        currentStep,
        winningOption,
        discountCode,
      } = this.props;

      const { copied } = this.state;

      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);
      const sizingStyle = {
        padding: '0',
        margin: '0',
        display: 'block',
        width: '100%',
        height: '100%',
      };

      _.extend(style, sizingStyle, {
        boxShadow: boxShadowStyle.insetBoxShadow,
        cursor: isPreview ? null : 'pointer',
      });

      const containerStyle = _.extend(sizingStyle, {
        position: 'relative',
        overflow: 'hidden',
        zIndex: 0,
        boxShadow: boxShadowStyle.boxShadow,
      }, _.pick(
        this.props.style.toJS(),
        'borderColor',
        'borderStyle',
        'borderTopLeftRadius',
        'borderTopRightRadius',
        'borderBottomLeftRadius',
        'borderBottomRightRadius',
        'borderTopWidth',
        'borderLeftWidth',
        'borderBottomWidth',
        'borderRightWidth',
      ));

      let text = this.props.text;
      if (currentStep === 'success' && !isPreview) {
        const prizeType = winningOption ? winningOption.get('prizeType') : null;

        if (text.indexOf('{game_result}') > -1 && winningOption) {
          text = text.replace(/{game_result}/g, winningOption.get('resultText') || '{game_result}');
        }

        if (text.indexOf('{prize_text}') > -1 && winningOption) {
          text = text.replace(/{prize_text}/g, winningOption.get('label') || '{prize_text}');
        }

        if (containsPrize(text)) {
          if (prizeType === 'discount' || discountCode) {
            text = text.replace(/{discount}/g, discountCode || '{discount}');
            text = text.replace(/{discount_code}/g, discountCode || '{discount_code}');
            text = text.replace(/{prize}/g, discountCode || '{prize}');
            if (!isPreview) style.cursor = 'pointer';
          } else if (prizeType === 'content') {
            text = text.replace(/{prize}/g, 'Download Prize');
          }
        }
      }

      if (copied) text = 'Copied!';

      return (
        <div
          style={containerStyle}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <button disabled={disabled} style={style} onClick={this.onClick}>{text}</button>
        </div>
      );
    }
  }

  return Button;
});
